import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colors } from '../../styles/colors/';

const StyledDiv = styled.div`
  margin-bottom: 18px;
  font-size: 18px;
  line-height: 28px;
  font-weight: 500;
  font-family: 'DM Sans', sans-serif;
  color: ${colors.indigo['7']};
`;

export const TableHeading = ({ children }) => {
  if (!children) return null;

  return <StyledDiv>{children}</StyledDiv>;
};

TableHeading.propTypes = { children: PropTypes.node };
